
import { balance, getUserInfo, RecvMsgParser, GetAuthList } from "@/service/GenerateAI/index";

import { MessageBox } from "element-ui";

const state = {
  // token: getToken(),
  // accessTokenProduct: getToken("accessTokenProduct"),
  currentTab: 0,
  balance: 0,
  logo: '',
  taskDetail: {} //更新任务详情
};
const mutations = {

  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_BALANCE: (state, val) => {
    state.balance = val
  },
  SET_TASKDETAIL: (state, val) => {

    state.taskDetail = val
  },
  SET_LOGO: (state, val) => {

    state.logo = val
  },
  SET_CURRENTTAB: (state, val) => {

    state.currentTab = val
  },
};
const actions = {
  // 点数余额不足时调用工单提醒
  async sendWorkOrderMsg() {
    getUserInfo().then(({ code, data }) => {
      if (code == 1) {
        RecvMsgParser({
          Equipment: "pc",
          registerSource: "1",
          Mobile: data.userInfo.phone,
          CaihongNo: data.orgInfo.caihongNO,
          platForm: "AI生成平台",
          name: data.userInfo.name,
          msgHandlecode: "C-AIXHDS",
          content: "客户AI生成消耗点数不足，可提醒客户增购",
        }).then(() => { }).catch(() => { });
      }
    });
    MessageBox({
      title: "提示",
      message: "您当前没有足够的点数进行此操作，已为您通知工作人员，请稍等",
      confirmButtonText: "我知道了",
    }).then(() => { }).catch(() => { });
  },

  // 设置token
  setTokenMsg({ commit }, data) {
    const tokenData = data.tokenHead + data.token;
    commit("SET_TOKEN", tokenData);
  },
  updateBalance({ commit }) {
    GetAuthList({ authCodes: ["T33", "T34"] }).then(({ data, code }) => {
      if (code == 1) {
        commit("SET_BALANCE", data[1].remain)
      }

    });

  },
  updateTaskDetail({ commit }, data) {
    commit("SET_TASKDETAIL", data)
  },
  updateLogo({ commit }, data) {
    commit("SET_LOGO", data)
  },
  updateCurrentTab({ commit }, data) {
    commit("SET_CURRENTTAB", data)
  },

  // 用户退出
  logout({ commit }) {
    let iframe = document.getElementById("iframeLogin");
    if (iframe) {
      iframe.contentWindow.postMessage({ type: "loginOut" }, "*");
    }
    if (!getToken()) {
      window.location.replace(process.env.VUE_APP_LOGIN_URL);
      return;
    }
    return new Promise((resolve, reject) => {
      logout()
        .then(async () => {
          commit("SET_TOKEN", "");
          commit("permission/CLEAR_ROUTES", "", { root: true });
          await removeToken();
          await resetRouter();
          clearStorage();
          // 退出刷新重置路由配置
          window.location.replace(process.env.VUE_APP_LOGIN_URL);
        })
        .catch(async (error) => {
          await removeToken();
          await resetRouter();
          clearStorage();
          // commit('permission/RESET_ROUTER');
          reject(error);
          window.location.replace(process.env.VUE_APP_LOGIN_URL);
        });
    });
  },



};


export default {
  // namespaced: true,
  state,
  mutations,
  actions
};
